import { useEffect } from 'react';
import './index.css';
import { LangProvider } from './LangContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Intro from './components/Intro';
import CallForArtists from './components/CallForArtists';
import Programma from './components/Programma';
import Location from './components/Location';
import Stripes from './components/Stripes';
import Partner from './components/Partner';
import { AboutSection, Footer } from './components/AboutFooter';
import PrivacyPolicy from './components/PrivacyPolicy';
import Regolamento from './components/Regolamento';
import CookieBanner from './components/CookieBanner';
import { useScrollReveal, useCursor } from './hooks';

function Site() {
  useScrollReveal();
  useCursor();
  const path = window.location.pathname;

  return (
    <>
      <div className="cursor" />
      <div className="cursor-ring" />
      <Navbar />
      <CookieBanner />
      {path === '/privacy' ? (
        <PrivacyPolicy />
      ) : path === '/regolamento' ? (
        <Regolamento />
      ) : (
        <>
          <Hero />
          <Intro />
          <CallForArtists />
          <Programma />
          <Location />
          <Stripes />
          <Partner />
          <AboutSection />
        </>
      )}
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <LangProvider>
      <Site />
    </LangProvider>
  );
}
